import React, { useState, useEffect } from "react";
import { ACTIONS } from "./context-store/ACTIONS";
import { PROGRESS_ALERT_VARIANTS } from "./components/ProgressAlerts/ProgressAlerts";
import IasNavHeader from "./components/NavHeader/NavHeader";
import IasPageWrapper from "./components/PageWrapper/PageWrapper";
import IasFormCreateCourse from "./components/FormCreateCourse/FormCreateCourse";
import IasProgressAlerts from "./components/ProgressAlerts/ProgressAlerts";
import IasAppSpinner from "./components/AppSpinner/AppSpinner";
import IasInfoModal from "./components/InfoModal/InfoModal";
import IasCreatedCourseModal from "./components/CreatedCourseModal/CreatedCourseModal";
import { useStateValue } from "./context-store/AppStateProvider";
import useCourses from "./hooks/useCourses";
import useAccount from "./hooks/useAccount";
import useTimezone from "./hooks/useTimezone";

import "./App.css";
import IasFormCreateCourseRestart from "./components/FormCreateCourseRestart/FormCreateCourseRestart";

const App = () => {
    const [{ isCreatedCourseModalOpen }, dispatch] = useStateValue();

    // Get dropdown data, pass down to component
    const { response, isLoading, error } = useCourses();
    const { response: accountResponse } = useAccount();
    const { response: timeZoneResponse } = useTimezone();
    const [dropdownOptions, setDropdownOptions] = useState([]);
    const [{ salesForceType }] = useStateValue();
    const [ displayMinorLearners, setDisplayMinorLearners ] = useState(false);
    const [ maximumLearners, setmaximumLearners] = useState(0);

    // ** Get API dta
    useEffect(() => {
        if(response && salesForceType === "restart" && !isLoading && !error) {
            setDropdownOptions(response);
            dispatch({
                type: ACTIONS.SET_IS_APP_LOADING,
                isAppLoading: false
            });
        } else if (response && !isLoading && !error) {
            setDropdownOptions(response);
            dispatch({
                type: ACTIONS.SET_IS_APP_LOADING,
                isAppLoading: false
            });
        }

        if (error && !isLoading && !response) {
            dispatch({
                type: ACTIONS.SET_IS_APP_LOADING,
                isAppLoading: false
            });

            dispatch({
                type: ACTIONS.SET_PROGRESS_ALERT,
                progressAlert: {
                    variant: PROGRESS_ALERT_VARIANTS.ERROR,
                    message: error.message
                }
            });
        }
    }, [response, isLoading, error, dispatch]);

    useEffect(() => {
        if (accountResponse) {
            setDisplayMinorLearners(accountResponse.displayMinorLearners);
            setmaximumLearners(accountResponse.maximumLearners);
        }
    }, [accountResponse]);

    if( salesForceType === "restart") {
        return (
            <div className="App">
                <IasAppSpinner/>

                <IasPageWrapper>
                    <IasNavHeader/>
                    <IasProgressAlerts/>
                    <IasFormCreateCourseRestart
                        dropdownOptions={dropdownOptions}
                        dropdownDataError={error}
                        userTimeZone={timeZoneResponse?.userTimeZone}
                    />
                </IasPageWrapper>

                <IasInfoModal
                    title={"Course Creation"}
                    bodyText={
                        "Explanation of course creation can be shown here. This modal can be this size or fullscreen."
                    }
                />

                {isCreatedCourseModalOpen && <IasCreatedCourseModal/>}
            </div>
        );
    } else {
        let type = ""
        switch(salesForceType) {
            case 'academy':
                type = "Academy";
                break;
            case 'spark':
                type = "Spark";
                break;
            default:
                type = "N/A"
        }

        return (
            <div className="App">
                <IasAppSpinner/>

                <IasPageWrapper>
                    <IasNavHeader/>
                    <IasProgressAlerts/>
                    <IasFormCreateCourse
                        dropdownOptions={dropdownOptions}
                        dropdownDataError={error}
                        userTimeZone={timeZoneResponse?.userTimeZone}
                        salesForceType={type}
                        displayMinorLearners={displayMinorLearners}
                        maximumLearners={maximumLearners}
                    />
                </IasPageWrapper>

                <IasInfoModal
                    title={"Course Creation"}
                    bodyText={
                        "Explanation of course creation can be shown here. This modal can be this size or fullscreen."
                    }
                />

                {isCreatedCourseModalOpen && <IasCreatedCourseModal/>}
            </div>
        );}
};

export default App;
